var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseInstance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_124742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 38.5L36.75 33.25L35.525 32.025L32.375 35.175V28H30.625V35.175L27.475 32.025L26.25 33.25L31.5 38.5ZM21 7L10.6312 12.9938L21 18.9875L31.3687 12.9938L21 7ZM5.25 27.9563V14.0437C5.25 13.4021 5.40342 12.8188 5.71025 12.2937C6.01708 11.7688 6.447 11.3458 7 11.025L19.25 3.98125C19.5417 3.83542 19.8263 3.71875 20.104 3.63125C20.3817 3.54375 20.6803 3.5 21 3.5C21.3197 3.5 21.6259 3.54375 21.9188 3.63125C22.2116 3.71875 22.4887 3.83542 22.75 3.98125L35 11.025C35.5542 11.3458 35.9847 11.7688 36.2915 12.2937C36.5983 12.8188 36.7512 13.4021 36.75 14.0437V21H33.25V15.925L20.9563 23.0125L8.75 15.925V27.9125L19.25 33.9937V38.0187L7 30.975C6.44583 30.6542 6.01592 30.2313 5.71025 29.7063C5.40458 29.1813 5.25117 28.5979 5.25 27.9563ZM31.5 42C29.0792 42 27.0159 41.1466 25.3103 39.4398C23.6046 37.7329 22.7512 35.6697 22.75 33.25C22.7488 30.8303 23.6023 28.7671 25.3103 27.0603C27.0183 25.3534 29.0815 24.5 31.5 24.5C33.9185 24.5 35.9823 25.3534 37.6915 27.0603C39.4007 28.7671 40.2535 30.8303 40.25 33.25C40.2465 35.6697 39.3931 37.7335 37.6898 39.4415C35.9864 41.1495 33.9232 42.0023 31.5 42Z",
    fill: "#C0C0C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_124742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseInstance);
export default __webpack_public_path__ + "static/media/course-instance.0df3c825c30764e78ef324649370ac6a.svg";
export { ForwardRef as ReactComponent };